type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: (...args: unknown[]) => void
  loaded: boolean
  version: string
}

type MetaWindow = Window & {
  fbq?: MetaPixelFunction
  _fbq?: MetaPixelFunction
  __metaPixelLoaded?: boolean
}

export const META_PIXEL_ID = '1038543325185457'

function createPixelStub(metaWindow: MetaWindow): MetaPixelFunction {
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args)
      return
    }
    pixel.queue.push(args)
  } as MetaPixelFunction

  pixel.queue = []
  pixel.push = (...args: unknown[]) => pixel.queue.push(args)
  pixel.loaded = true
  pixel.version = '2.0'
  metaWindow.fbq = pixel
  metaWindow._fbq = pixel
  return pixel
}

/**
 * Loads the Meta Pixel exactly once per browser session and fires a single
 * PageView. The load flag lives on `window`, so React re-mounts (including
 * StrictMode's double effect in development) cannot re-initialise the pixel or
 * duplicate the event.
 */
export function loadMetaPixel(): void {
  if (typeof window === 'undefined') return

  const metaWindow = window as MetaWindow
  if (metaWindow.__metaPixelLoaded) return
  metaWindow.__metaPixelLoaded = true

  const pixel = metaWindow.fbq ?? createPixelStub(metaWindow)

  if (!document.querySelector('script[data-meta-pixel="true"]')) {
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.dataset.metaPixel = 'true'
    document.head.appendChild(script)
  }

  pixel('init', META_PIXEL_ID)
  pixel('track', 'PageView')
}
